import { DistributionTypeEnum } from '@api/ringil-api.v2.tsx';

/**
 * Distribution types where the carrier answers with his own CarrierQuote (state lives in carrierQuoteState),
 * as opposed to FIXED_PRICE / ASSIGN where the carrier only accepts the customer's quote.
 * CONTRACTED ("Smluvní dopravce") behaves like SPOT, only the price is given by the contract.
 * Mirrors backend DistributionNewType.isCarrierQuoteBased().
 */
export const isCarrierQuoteBased = (type: DistributionTypeEnum | string | null | undefined): boolean =>
  type === DistributionTypeEnum.SPOT || type === DistributionTypeEnum.CONTRACTED;

export const isContracted = (type: DistributionTypeEnum | string | null | undefined): boolean =>
  type === DistributionTypeEnum.CONTRACTED;
